import { IUpdateClienteUseCase } from "../../../presentation/useCases/update/update_cliente_use_case";
import { Cliente } from "../../models/cliente";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateClienteUseCase
 */

export class UpdateClienteUseCase implements IUpdateClienteUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: Cliente): Promise<void> {
    await this.repository.updateCliente(form);

  }
}
